export default {
  path: "/HighlightedTopic/FatalCrash",
  name: "Highlighted Topic - Fatal Crash",
  type: "highlightedTopic",
  htmlContent: "HT-FatalCrash.html",
  keyPoints: [
    "If a person did not die at the scene but died following the motor vehicle crash in which the injury occurred, it is required that a supplemental report be submitted updating their injury code to “1 – Fatal Injury (K)”.  ",
  ],
  keywords: ["Fatal", "Fatality", "dead", "killed", "victim", "Fatal Injury", "K", "death"],
};
